// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"y4-z"};